import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AuthService, GoogleLoginProvider} from 'angularx-social-login';
import { AccountService } from '../account.service';
import { FirebaseService } from 'app/services/firebase.service';
import { ActivatedRoute } from '@angular/router';
import { FacebookPixelService } from 'app/services/facebook-pixel.service';

@Component({
  selector: 'google-login',
  templateUrl: './google-login.component.html',
  styleUrls: ['../account.scss']
})
export class GoogleLoginComponent implements OnInit {
  @Output() isLoading = new EventEmitter();
  @Output() setError = new EventEmitter();
  @Input() redirectUrl;
  @Input() isSignUp;

  constructor(
    private authService: AuthService,
    public accountService: AccountService,
    private firebaseService: FirebaseService,
    public activatedRoute: ActivatedRoute,
    private facebookPixelService: FacebookPixelService,
  ) { }

  ngOnInit() {
  }

  signInWithGoogle(): void {
    this.authService.authState.subscribe((user) => {
      if (user) {
        this.accountService.signInWithGoogle(user.authToken, this.redirectUrl, this.isSignUp)
        .subscribe(
          data => {
            if (!this.isSignUp) {
              // this.firebaseService.setUserId(data.user_id);
              this.firebaseService.logEvent('login', {
                method: 'google',
              });
            } else {
              this.firebaseService.logEvent('sign_up', {
                method: 'google',
              });
              this.facebookPixelService.trackEvent('CompleteRegistration' , {
                method: 'google',
              });
            }
            this.isLoading.emit(false);
          },
          errors => {
            if (!this.isSignUp) {
              this.firebaseService.logEvent('login_error', {
                reason: errors.detail,
              });
            } else {
              this.firebaseService.logEvent('sign_up_error', {
                reason: errors.detail,
              });
            }
            this.setError.emit(errors);
            this.isLoading.emit(false);
          }
        );
      }
    });
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signOut(): void {
    this.authService.signOut();
  }


}
